import View from './view';
export const Loader = View;
